import { historyMiddleware } from './routing/middleware'
import { sagaMiddleware } from './sagas'
import persistence from './persistence';

export const middleware = [ historyMiddleware, sagaMiddleware, persistence ]
